<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button type="primary" class="filter-item" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="券包名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="券包总额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.discount_total }}
        </template>
      </el-table-column>

      <el-table-column label="券数量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.num_total }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="250" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">查询</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="券包名称" prop="name">
          <el-input v-model="form.name" :disabled="!!form.id"></el-input>
        </el-form-item>

        <el-form-item label="优惠券" prop="detail">
          <el-button icon="el-icon-plus" size="mini" plain @click="handelDetailAdd" :disabled="!!form.id"></el-button>

          <el-table :data="form.detail" border fit>
            <el-table-column label="优惠券id" min-width="110" align="center">
              <template slot-scope="scope">
                <el-select size="small" v-model="scope.row.coupon_id" filterable style="width: 100%;max-width: 220px;">
                  <el-option v-for="item in couponList" :key="item.id" :label="formatLabel(item)" :value="item.id" :disabled="!!form.id">
                    <div style="display: flex;align-items:center;text-align:center;">
                      <span>{{ item.id }}</span>

                      <span>---</span>
                      <span v-if="item.coupon_scope === 1">全平台</span>
                      <span v-else-if="item.coupon_scope === 2">{{item.shop.shop_name}}</span>
                      <span v-else-if="item.coupon_scope === 3" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 140px;" :title="item.shop_names">{{item.shop_names}}</span>

                      <span>---</span>
                      <span v-if="item.coupon_type === 1">无门槛 </span>
                      <span v-else-if="item.coupon_type === 2">满{{item.minimum}}可用</span>
                      <span v-else-if="item.coupon_type === 3">商品优惠</span>

                      <span>---</span>
                      <span v-if="item.coupon_type === 3">
                        <template v-if="item.discount_mode === 1">商品优惠{{item.discount_num}}折</template>
                        <template v-else-if="item.discount_mode === 2">商品立减{{item.discount}}元</template>
                      </span>
                      <span v-else>优惠立减{{ item.discount }}元</span>
                    </div>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="赠送数量" min-width="110" align="center">
              <template slot-scope="scope">
                <el-input-number size="small" v-model="scope.row.num" :min="1" :precision="0" style="width: 100%;max-width: 220px;" :disabled="!!form.id"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="110" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="handelDetailDelete(scope.$index)" :disabled="!!form.id">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!form.id">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: 0,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          create: "新增",
          update: "修改"
        },
        form: {
          id: "",
          school_id: "",
          name: "",
          detail: [],
        },
        rules: {
          name: [{ required: true, message: "券包名称不能为空", trigger: "change" }],
          detail: [{ required: true, message: "优惠券不能为空", trigger: "change" }],
        },
        btnLoading: false,
        // 优惠券列表
        couponList: null
      };
    },
    created() {
      this.getCouponList();
      this.getList();
    },
    computed: {
      ...mapGetters(["schools", "school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
        this.getCouponList();
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/couponProduct/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      getCouponList() {
        request({
          url: "/api/backend/coupon/list",
          method: "get",
          params: {
            page: 1,
            limit: 100000,
            package_type: 2,
            school_id: this.school_id,
            release: 1,
            expire: 0,
          }
        }).then(response => {
          this.couponList = response.data.data;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          name: "",
          detail: [],
        };
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm();
        this.dialogStatus = "create";
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.$refs["form"].clearValidate(); //清除校验结果
        });
      },
      handleUpdate(row) {
        this.resetForm();
        this.form = JSON.parse(JSON.stringify(row))
        this.dialogStatus = "update";
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.$refs["form"].clearValidate(); //清除校验结果
        });
      },
      saveData() {
        if (!this.school_id) {
          this.$message({
            type: "warning",
            message: "请选择学校"
          });
          return;
        } else {
          this.form.school_id = this.school_id
        }
        for (let index = 0; index < this.form.detail.length; index++) {
          const element = this.form.detail[index];

          if (element.coupon_id === "") {
            this.$message({
              type: "warning",
              message: "优惠券id不能为空",
            });
            return;
          }

          if (element.num === undefined) {
            this.$message({
              type: "warning",
              message: "赠送数量不能为空",
            });
            return;
          }
        }

        this.$refs["form"].validate(valid => {
          if (valid) {
            this.btnLoading = true;
            request({
              url: "/api/backend/couponProduct/save",
              method: "post",
              data: this.form
            })
            .then(() => {
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            })
            .catch(err => {
              console.log(err);
            })
            .finally(() => {
              this.btnLoading = false;
            });
          }
        });
      },
      formatLabel(item) {
        const truncate = (str, len = 10) => {
          if (!str) return "";
          return str.length > len ? str.substring(0, len) + "..." : str;
        };

        let scopeText = "";
        if (item.coupon_scope === 1) {
          scopeText = "全平台";
        } else if (item.coupon_scope === 2) {
          scopeText = item.shop?.shop_name || "";
        } else if (item.coupon_scope === 3) {
          scopeText = truncate(item.shop_names);
        }

        let typeText = "";
        if (item.coupon_type === 1) {
          typeText = "无门槛";
        } else if (item.coupon_type === 2) {
          typeText = `满${item.minimum}可用`;
        } else if (item.coupon_type === 3) {
          typeText = "商品优惠";
        }

        let discountText = "";
        if (item.coupon_type === 3) {
          if (item.discount_mode === 1) {
            discountText = `商品优惠${item.discount_num}折`;
          } else if (item.discount_mode === 2) {
            discountText = `商品立减${item.discount}元`;
          }
        } else {
          discountText = `优惠立减${item.discount}元`;
        }

        return `${item.id}---${scopeText}---${typeText}---${discountText}`;
      },
      // 详情
      handelDetailAdd() {
        this.form.detail.push({
          coupon_id: "",
          num: 1,
        });
      },
      handelDetailDelete(index) {
        this.form.detail.splice(index, 1);
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
